// extracted by mini-css-extract-plugin
export default {"scroll":"request-list_scroll__39qjx"};